import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-border mt-auto" role="contentinfo">
      <div className="max-w-6xl mx-auto px-5 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} Le Cobaye. Tous droits reserves.
        </p>
        <nav aria-label="Liens du pied de page" className="flex items-center gap-4">
          <Link to="/a-propos" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            A propos
          </Link>
          <Link to="/categories" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
            Categories
          </Link>
        </nav>
      </div>
    </footer>
  );
}
